export const ligas_lnteres = [
    {
        "anio" : "2026",
        "descripcion" : "",
        "ligas" : [
            {
                "liga" : "Informe Anual de Resultados del Programa Anual de Desarrollo Archivístico 2025",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/Informe_Programa_Anual_Desarrollo_Archivistico_2025.pdf"
            },{
                "liga" : "Codigo de Etica",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/etica.pdf"
            },{
                "liga" : "Codigo de Conducta",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/conducta.pdf"
            },{
                "liga" : "Revista del Comité de Ética y Prevención de Conflictos de Interés",
                "url" : "../assets/pdf/revista_codigo/"
            },{
                "liga" : "Lineamientos de tecnologías de información, comunicaciones y seguridad informática",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/lineamientos_tecnologias_2023.pdf"
            },{
                "liga" : "Plan de Prevención de Desastres",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/Plan_prevencion_desastres.pdf"
            },{
                "liga" : "Reglamento Interior 2026",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/REGLAMENTO_INTERIOR_STPSH_06-2026.pdf"
            },{
                "liga" : "Reglamento Interior 2023",
                "url" : "https://periodico.hidalgo.gob.mx/?tribe_events=periodico-oficial-alcance-7-del-28-de-julio-de-2023"
            },{
                "liga" : "Reglamento Interior 2022",
                "url" : "https://periodico.hidalgo.gob.mx/?tribe_events=periodico-oficial-ordinario-0-del-28-de-febrero-de-2022"
            },{
                "liga" : "Reglamento Interior 2017",
                "url" : "https://periodico.hidalgo.gob.mx/?tribe_events=Periodico-Oficial-Alcance-1-del-27-de-julio-de-2017"
            },{
                "liga" : "Manual de Organización",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir1/fraccionI/MO_STPSH_2022.pdf"
            },{
                "liga" : "Manual de Procedimientos",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir1/fraccionI/MP_STYPSH_2022.pdf"
            },{
                "liga" : "Plan de Comunicación Interna y Externa",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/Plan_Comunicacion.pdf"
            },{
                "liga" : "Plan Estatal de Desarrollo",
                "url" : "http://tenemosunacuerdo.hidalgo.gob.mx/pdf/PLAN%20ESTATAL.pdf"
            },{
                "liga" : "Programa Sectorial de Desarrollo del Trabajo y la Previsión Social 2023 - 2028",
                "url" : "http://tenemosunacuerdo.hidalgo.gob.mx/pdf/PROGRAMAS_SECTORIALES/Programa_Sectorial_de_Desarrollo_del_Trabajo_y_la_Prevision_Social.pdf"
            },{
                "liga" : "Sistema Alterno de Inspección Laboral (Sail)",
                "url" : "/Sail"
            },{
                "liga" : "Políticas para la Consulta y Generación de Información Confiable",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/informacion_confiable.pdf"
            },{
                "liga" : "Proyecto de Mecanismos de Responsabilidad en la Rendición de Cuentas",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/rendicion_cuentas.pdf"
            },{
                "liga" : "Programa Anual de Mejora Regulatoria de Tramites y Servicios de la STPSH",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PROGRAMA_ANUAL_MEJORA_REGULATORIA_2024_STPSH.pdf"
            },{
                "liga" : "Glosa del Segundo Informe de Gobierno Secretaría del Trabajo y Previsión Social",
                "url" : "https://s-trabajo.hidalgo.gob.mx/Comparecencia/STPSH_2024.pdf"
            },{
                "liga" : "Glosa del Primer Informe de Gobierno Secretaría del Trabajo y Previsión Social",
                "url" : "https://s-trabajo.hidalgo.gob.mx/Comparecencia/STPSH_2023.pdf"
            },{
                "liga" : "Programa Institucional de Desarrollo del Centro de Conciliación Laboral 2023-2028",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PID_CCLEH_2023_2028.pdf"
            },{
                "liga" : "Informe Anual de Resultados del Programa Anual de Desarrollo Archivístico 2024",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/IARPADA_2024.pdf"
            }
        ]
    }
]